import LayoutAnalytics from '../analytics/analytics';
import LayoutNew from './quick-add/quick-add';
import LayoutTop from '../top/layout-top';
import UIFullModal from '../components/full-modal/full-modal';
import LayoutLocalSettings from './local-settings';
import ConstLayout from "../../core/gd/const/layout";
import calculateNativeScrollWidth from "./actions/calculate-native-scroll-width";
import getScreenSize from "./actions/get-screen-size";
import {LayoutMenuState} from "./const";
import getMainAreaSize from "./actions/get-main-size";
import {
    BUS_LAYOUT_MENU_MIN_POPOVER_CHAGED,
    EVENT_BUS_LAYOUT_ON_HEIGHT_CHANGE,
    EVENT_BUS_LAYOUT_ON_HEIGHT_MAIN_CHANGE,
    EVENT_BUS_LAYOUT_ON_WIDTH_CHANGE,
    EVENT_BUS_LAYOUT_ON_WIDTH_MAIN_CHANGE
} from "./bus-events";
import MainMenuStatic from "../menu/main-menu";
import NavigationPanel from "../navigation/navigation-panel";
import UILeft_Default from "../ui/classic/menu/left";
import ProjectHeaderLocalSettings from "../top/header/project/local-settings";
import LayoutLoading from "../components/loading/loading";
import UIRightPanel from "../right-panel/right-panel";
import layoutFullScreenEnable from "./actions/full-screen-enable";
import layoutFullScreenDisable from "./actions/full-screen-disable";
import LayoutContextMenu from "../context-menu/context-menu"
import ProjectSession from "../../core/model2/project/project-session"
import Popovers from "../popovers/popovers";
import {IconType} from "../../core/gd-components/selector/icon-selector/@const";
import {BUS_MAIN_MENU_OUTSIDE_CLICK} from "../navigation/@const";
import {UIType} from "../ui/@const";
import {NavigationSectionType} from "../../core/model2/navigation/@const";
import UIRightPanelMain from "../right-panel-main/right-panel-main";

// const debug = 'LayoutProto'
const debug = false

export default class LayoutProto {

    public type     : UIType

    // Main Menu elements
    public mainMenuStatic           : MainMenuStatic | null     = null // Link to current menu component
    // public mainMenuPopover          : MainMenuPopover | null    = null // Link to current menu component we use when menu = minimized



    public scrollWidth              : number = 0

    public domZero                  : any   // dom node link



    // public topPanel:number =  50 // , I THINK NOT IN USE

    public loading!                 : LayoutLoading // loading manager - initialized from LayoutLoading constructor
    public viewLoading              : any // ? loading for itemview ?

    public right!                   : UIRightPanel      // dumau eto new right container
    public rightMain!               : UIRightPanelMain  // link ro Right Panel Comnponent


    public fullModal               : UIFullModal = new UIFullModal() // Need change

    // Layout Apps

    public navigation!             : NavigationPanel    // link to navigationPanel TSX  !
    public analytics               : LayoutAnalytics    // everything related to analytics

    public new                     : LayoutNew          // everything related to new
    public left!                   : UILeft_Default             // Left component(tsx) initialized by component
    public top                     : LayoutTop          // everything related to top
    public localSettings           : LayoutLocalSettings

    public fullScreenEnabled       : boolean   = false     // convert to private ?
    public isMenuPopoverShown      : boolean   = false
    public menuMinPopoverShown     : boolean   = false     // true when wi in min menu and have shown meneu in popover
    public isRightFilterOpened     : boolean   = false     // est' voprosi nuzno li ono

    private debouncedWinResize     : any   // debounced callback when user resize browser

    public contextMenu              : LayoutContextMenu

    public popovers                 : Popovers = new Popovers()
    public activeTabBar             : IconType | null = null   // Poka dlya IconTabs ispolzuetsya

    // Sizes
    private _width                   : number            // window width
    private _height                  : number           // window height

    private _widthMain               : number        // main area with
    private _heightMain              : number       // main area height

    // Menu

    public menuState                : LayoutMenuState
    public isMenuHiddenForCurrentApp: boolean       = false

    public widthToAutoToggleMenu    : number = 1100 // this should be redefined for eatch layout!

    // public navigationPanelSize      : number = 60 // width or height based on layout // Old
    public navigationPanelSize      : number = gd.ui.leftNavigationPanelSize // width or height based on layout

    private _nodeMainCenter         : any   // main center html node
    private _nodeUILeft             : any   // main center html node

    constructor() {

        this.type           = UIType.LEFT

        this.scrollWidth    = calculateNativeScrollWidth() || 0

        this.analytics      = new LayoutAnalytics()
        this.new            = new LayoutNew()
        this.top            = new LayoutTop()
        this.contextMenu    = new LayoutContextMenu()

        this.localSettings  = new LayoutLocalSettings();

        // on Window Resize
        this.debouncedWinResize = _.debounce(this.onWindowResize.bind(this), 300);
        window.addEventListener('resize', this.debouncedWinResize);



        const screenSize    = getScreenSize()
        this._width         = screenSize.width;
        this._height        = screenSize.height;

        const mainSize      = getMainAreaSize()
        this._widthMain      = mainSize.width
        this._heightMain     = mainSize.height

        this.menuState  = this.getDefaultMenuState()

    }

    __destroy() {
        // a nahrena ?
        debug &&  console.log(debug,"__destroy");
        window.removeEventListener('resize', this.debouncedWinResize);
    }

    getDefaultMenuState() {

        if (!gd.ui.isMinimizeMenuAllowed && !this.shouldHideMenuBecauseOfScreenSize) {
            return LayoutMenuState.STATIC
        }

        if (this.localSettings.forcedMin) {
            return LayoutMenuState.MINIMIZED_BY_USER
        } else if (this.shouldHideMenuBecauseOfScreenSize)  {
            return LayoutMenuState.MINIMIZED_SMALL_SCREEN
        } else {
            return LayoutMenuState.STATIC
        }
    }

    get isTop(): boolean {
        return this.type === UIType.TOP
    }

    get isLeft(): boolean {
        return this.type === UIType.LEFT
    }

    // use this to access current menu
    get currentMenu():MainMenuStatic | null {

        return this.mainMenuStatic

        // if (this.menuState === LayoutMenuState.STATIC) {
        //     return this.mainMenuStatic
        // } else {
        //     return this.mainMenuPopover
        // }
    }

    get shouldHideMenuBecauseOfScreenSize() {
        return this.width <= this.widthToAutoToggleMenu
    }

    // called from menu to see if we need run meny appearance animation
    get shouldAnimateMenu():boolean {
        // return gd.layout.leftSize !== 'min'
        return true
    }

    get uiMainCenterNode() {
        if (!this._nodeMainCenter) this._nodeMainCenter = document.getElementById('ui-main-center')
        return this._nodeMainCenter
    }

    get uiLeftNode() {

        this._nodeUILeft = document.getElementById('ui-left')
        return this._nodeUILeft

        // Old. Tak nelzya teper'! Eto soxranyaet stariy node pri smene Skin.
        // if (!this._nodeUILeft) this._nodeUILeft = document.getElementById('ui-left')
        // return this._nodeUILeft
    }

    // ON OFF proxy

    public on(event:string, callback:callback, context?:any) : void {

        // console.log(context, callback)

        switch (event) {

            case 'change:widthMain':
                gd.bus.subscribe(EVENT_BUS_LAYOUT_ON_WIDTH_MAIN_CHANGE, context, callback)
                break

            case 'change:heightMain':
                gd.bus.subscribe(EVENT_BUS_LAYOUT_ON_HEIGHT_MAIN_CHANGE, context, callback)
                break

            default:
                console.orange("SUBSCRIBE to "+event)
                console.red("Unknonw envent #039393"+event)
        }


    }

    public off(event:string, calback:callback, context?:any) : void {
        // console.brown("layout.UNSUBSCRIBE to "+event)

        switch (event) {
            case 'change:widthMain':
                gd.bus.unsubscribeFromEvent(EVENT_BUS_LAYOUT_ON_WIDTH_MAIN_CHANGE, context)
                break
            case 'change:heightMain':
                gd.bus.unsubscribeFromEvent(EVENT_BUS_LAYOUT_ON_HEIGHT_MAIN_CHANGE, context)
                break
            default:
                console.red("Unknonw envent #039393"+event)
        }
    }

    // WIDTH/HEIGHT get set

    get width():number {
        return this._width
    }

    set width(value:number) {
        if (this._width === value) return

        this._width = value
        gd.bus.triggerEvent(EVENT_BUS_LAYOUT_ON_WIDTH_CHANGE, this._width)
    }

    get height():number {
        return this._height
    }

    set height(value:number) {
        if (this._height === value) return

        this._height = value
        gd.bus.triggerEvent(EVENT_BUS_LAYOUT_ON_HEIGHT_CHANGE, this._height)
    }

    get widthMain():number {
        return this._widthMain
    }

    set widthMain(value:number) {
        if (this._widthMain === value) return

        this._widthMain = value
        // console.orange("trigger event on widthMain:change")
        gd.bus.triggerEvent(EVENT_BUS_LAYOUT_ON_WIDTH_MAIN_CHANGE, this._widthMain)
    }

    get heightMain():number {
        return this._heightMain
    }

    set heightMain(value:number) {
        if (this._heightMain === value) return

        this._heightMain = value
        // console.orange("trigger event on heightMain:change")
        gd.bus.triggerEvent(EVENT_BUS_LAYOUT_ON_HEIGHT_MAIN_CHANGE, this._heightMain)
    }

    //

    calculateWidth() {
        debug &&  console.log(debug,"calculate width");

        const screenSize    = getScreenSize()
        this.width          = screenSize.width
        this.height         = screenSize.height

        const mainSize      = getMainAreaSize()
        this.widthMain      = mainSize.width
        this.heightMain     = mainSize.height
    }

    setRightFilterOpen(value:boolean) {
        this.isRightFilterOpened = value;
    }

    onWindowResize() {
        debug &&  console.log(debug,"onWindowResize()");

        // screen width
        const screenSize    = getScreenSize()
        this.width          = screenSize.width;
        this.height         = screenSize.height;

        // // check if left size changes
        // let newLeftSize : any = false;
        // if (!this.localSettings.forcedMin) {
        //     newLeftSize = getLeftSize(screenSize.width);
        //     if (this.leftSize === newLeftSize) newLeftSize = false;
        // } else {
        //     newLeftSize = 'min';
        //     if (this.leftSize === newLeftSize) newLeftSize = false;
        // }
        //
        // // if left size changed - apply it
        // if (newLeftSize) {  // it can be 0 !
        //     // div0 apply classes
        //     const oldLeftSize = this.leftSize;
        //     this.leftSize = newLeftSize;
        //
        //     if (newLeftSize==='min') gd.bus.triggerEvent('layout:min:on');
        //     else if (oldLeftSize==='min') gd.bus.triggerEvent('layout:min:off');
        //
        //     gd.utils.Dom.removeAllClasses(this.domZero);
        //     gd.utils.Dom.addClasses(this.domZero, 'ui-layout', this.type); // 'left-'+newLeftSize,
        // }

        // well ... if menu min... let's update

        this.calculateWidth();

        this.menuAutoToggleOnResize();

        debug &&  console.log(debug,".onWindowResize DONE - new widthFull=",this.width," widthMain=",this.widthMain);
    }

    applyTopPanelSettings(value:any) {
        debug && console.log(debug, "applyTopPanelSettings", value)

        if (!value) {
            this.top.close();
        } else {

            let newHeight = ConstLayout.TOP_WITHOUT_SUBMENU;

            if (value.companyId) {
                newHeight = ConstLayout.TOP_WITHOUT_SUBMENU;
            }

            if (value.companyUserId) {
                newHeight = ConstLayout.TOP_WITH_SUBMENU;
            }

            if (value.projectId) {
                const project: ProjectSession | null = gd.session.projects.get(value.projectId);

                const localSettings = new ProjectHeaderLocalSettings()
                if (project && !project.isView) {
                    if (localSettings.isSubmenuCompact(value.projectId)) {
                        newHeight = ConstLayout.TOP_WITHOUT_SUBMENU
                    } else {
                        newHeight = ConstLayout.TOP_WITH_SUBMENU
                    }
                }

                // if (project) newHeight = ConstLayout.TOP_WITH_SUBMENU;
            }

            if (value.projectCollectionId) {
                const projectCollection = gd.session.projectCollections.get(value.projectCollectionId)
                if (projectCollection) newHeight = ConstLayout.TOP_WITH_SUBMENU
            }

            // custom height
            if (value.height) newHeight = value.height;


            if (value.extensions) {
                // first exteneded line
                newHeight += value.extensions[0];

                // second line ?
                if (value.extensions.length>2) {
                    newHeight += value.extensions[2];
                }
            }

            this.top.open(newHeight);

        }

        this.calculateWidth();
    }

    fullScreen(enabled:boolean) {

        debug && console.log(debug, "fullScreen() enabled=", enabled)

        this.fullScreenEnabled = enabled;

        if (enabled) {
            layoutFullScreenEnable()
        } else {
            layoutFullScreenDisable()
        }

        setTimeout(()=>{gd.layout.calculateWidth()},0);
    }

    isFullScreenEnabled() {
        return this.fullScreenEnabled;
    }

    //menu layout methods

    get hasMainMenuInCurrenApp() {

        const currentApp = gd.getApp()

        return !!currentApp?.navigationSection?.menuComponent ||
            !!currentApp?.navigation?.menuComponent ||
            !!currentApp?.navigation?.navigationSection?.menuComponent ||
            !!currentApp.space?.navigation?.menuComponent
    }

    menuAutoToggleOnResize() {

        if (debug) console.log(debug,"menuAutoToggleOnResize() - check if we need to hide menu because of screen size");

        if (this.shouldHideMenuBecauseOfScreenSize) {
            console.orange("screen is small")
            // need adjust if needed
            if (this.menuState===LayoutMenuState.MINIMIZED_SMALL_SCREEN) {
                console.orange("    do nothing - was small keeps small")
                return
            }

            // console.orange("    need minimize")
            this.menuState = LayoutMenuState.MINIMIZED_SMALL_SCREEN
            this.applyStyles()

        } else {
            // console.orange("screen is big")
            // need reset if needed
            if (this.menuState === LayoutMenuState.MINIMIZED_SMALL_SCREEN) {
                this.menuState = this.getDefaultMenuState()

                if (this.hasMainMenuInCurrenApp) {
                    this.applyStyles()
                }
            }

        }

        this.calculateWidth() // Without this, there will be a bug with auto hiding "Top submenu items" on resize window.

        // const open = !this.shouldHideMenuBecauseOfScreenSize
        //
        // if (this.localSettings.isMenuOpen !== open) {
        //     gd.layout.localSettings.isMenuOpen = open
        //     gd.layout.localSettings.save()
        //
        //     gd.layout.left.process()
        // }
        //
    }


    toggleForceMin() {

        // Important trigger for update new navbar UI
        gd.bus.triggerEvent(BUS_MAIN_MENU_OUTSIDE_CLICK)

        this.localSettings.forcedMin = !this.localSettings.forcedMin
        this.localSettings.save()

        // set menu State
        this.menuState = this.getDefaultMenuState()

        // if (this.localSettings.forcedMin) {
        //     this.menuState = LayoutMenuState.MINIMIZED_BY_USER
        // } else if (this.shouldHideMenuBecauseOfScreenSize)  {
        //     this.menuState = LayoutMenuState.MINIMIZED_SMALL_SCREEN
        // } else {
        //     this.menuState = LayoutMenuState.STATIC
        // }

        // gd.bus.triggerEvent(TOGGLE_MENU_SIZE);

        this.left.reRender() // we need rerender to update minimize button state ...

        this.applyStyles()

        // this.onWindowResize();
    }

    toggleMenuMinPopover(value:any) {

        // console.log("new value=", value, "currentValue=", this.menuMinPopoverShown)
        if (this.menuMinPopoverShown===value) {
            // this prevents un-necessary renders for navigation panel
            return
        }

        console.warn("using trigger here not a good idea I think we shoudl use direct link gd.layout.navigation")

        this.menuMinPopoverShown = !_.isNil(value) ? value : !this.menuMinPopoverShown;
        gd.bus.triggerEvent(BUS_LAYOUT_MENU_MIN_POPOVER_CHAGED, this.menuMinPopoverShown);
    }

    get isStaticMenu() {
        return this.menuState === LayoutMenuState.STATIC
    }

    toggleHideMenuForCurrentApp(hide: boolean) {
        debug && console.log(debug, "toggleHideMenuForCurrentApp hide=", hide)

        const originalState = this.menuState

        if (hide) {
            this.menuState = LayoutMenuState.APP_NO_MENU
        } else {
            this.menuState = this.getDefaultMenuState()
        }

        // if (this.menuState === originalState) {
        //     debug && console.log(debug, "same state -> skip")
        //     return
        // }

        this.isMenuHiddenForCurrentApp  = hide

        this.applyStyles()

        this.calculateWidth()

        // Without this, there will be a bug. The menu state changes, but the navbar doesn't know about it.
        this.navigation.reRender()
    }

    get uiLeftLeftPosition():any {

        let mainCenterLeft : number = gd.ui.leftNavigationPanelSize

        switch (this.menuState) {
            case LayoutMenuState.STATIC:
                // make left visible
                return mainCenterLeft
            case LayoutMenuState.MINIMIZED_BY_USER:
            case LayoutMenuState.MINIMIZED_SMALL_SCREEN:
            case LayoutMenuState.APP_NO_MENU:
                return mainCenterLeft-this.localSettings.menuWidth

            default:
                console.error("#983736 not meant to happen")
                break
        }
    }


    applyStyles() {

        debug && console.green(debug, "applyStyles()")

        let mainCenterLeft : number
        let mainCenterWidth : string

        // Set left border radius for center block dynamically for Click up skin
        if (gd.ui.type === UIType.CLICK_UP && (gd.layout.menuState !== LayoutMenuState.STATIC || gd.layout.isMenuHiddenForCurrentApp)) {
            this.uiMainCenterNode.classList.add("left-border-radius")
        } else {
            this.uiMainCenterNode.classList.remove("left-border-radius")
        }

        if (gd.ui.type === UIType.TOP ) {
            mainCenterLeft = 0
        } else {
            mainCenterLeft = gd.ui.uiCenterLeftSpace;
        }

        switch (this.menuState) {
            case LayoutMenuState.STATIC:

                mainCenterLeft += this.localSettings.menuWidth

                // Dynamic calc for different skins GOODDAY, TEAMS
                switch (gd.ui.type) {
                    case UIType.TEAMS:
                    case UIType.CLICK_UP:
                        mainCenterWidth = `calc(100% - ${mainCenterLeft + 6}px)`
                        break
                    case UIType.GOODDAY_MODERN:
                        mainCenterWidth = `calc(100% - ${mainCenterLeft + 8}px)`
                        break
                    case UIType.LEFT:
                    case UIType.TOP:
                    default:
                        mainCenterWidth = `calc(100% - ${mainCenterLeft}px)`
                }

                // right panel - move it to the left and adjust width
                this.uiMainCenterNode.style.left = mainCenterLeft + 'px'
                this.uiMainCenterNode.style.width = mainCenterWidth

                // rerender current menu according to new isMenuHiddenForCurrentApp value
                this.currentMenu?.reRender(true)

                break

            case LayoutMenuState.MINIMIZED_BY_USER:
            case LayoutMenuState.MINIMIZED_SMALL_SCREEN:
            case LayoutMenuState.APP_NO_MENU:

                // left panel - move it to the very left (hidden)

                if (gd.ui.type === UIType.TEAMS) {
                    // Hide uiLeft out of the window. Because the Teams navigation bar requires it. !!!!!!
                    this.uiLeftNode.style.left =  mainCenterLeft-this.localSettings.menuWidth - 5 +'px'
                } else {
                    this.uiLeftNode.style.left =  mainCenterLeft-this.localSettings.menuWidth +'px'
                }

                // Dynamic calc for different skins GOODDAY, TEAMS, CLICK UP
                switch (gd.ui.type) {
                    case UIType.TEAMS:
                    case UIType.CLICK_UP:
                        mainCenterWidth = `calc(100% - ${mainCenterLeft + 6}px)`
                        break
                    case UIType.GOODDAY_MODERN:
                        mainCenterWidth = `calc(100% - ${mainCenterLeft + 8}px)`
                        break
                    case UIType.LEFT:
                    case UIType.TOP:
                    default:
                        mainCenterWidth = `calc(100% - ${mainCenterLeft}px)`
                }


                // right panel - move it to the left and adjust width
                this.uiMainCenterNode.style.left = mainCenterLeft + 'px'
                this.uiMainCenterNode.style.width = mainCenterWidth


                // rerender current menu according to new isMenuHiddenForCurrentApp value
                this.currentMenu?.reRender(true)
                break

            default:
                console.error("#kldjdh9374 not meant to happen")
                break
        }


        // we need to add / remove class to hide minimize button
        switch (this.menuState) {
            case LayoutMenuState.STATIC:
            case LayoutMenuState.MINIMIZED_BY_USER:
                this.uiLeftNode.classList.remove('no-minimize-btn')
                break
            case LayoutMenuState.MINIMIZED_SMALL_SCREEN:
            case LayoutMenuState.APP_NO_MENU:
                this.uiLeftNode.classList.add('no-minimize-btn')
                break

            default:
                console.error("#kldjdh9374 not meant to happen")
                break
        }

        this.left.reRender()
    }

    public restart(): void {

        const currentApp = gd.getApp()

        debug && console.log(debug, "restart()")

        gd.skin.init()
        gd.layout.render()

        if (this.menuState !== LayoutMenuState.STATIC) {
            this.toggleHideMenuForCurrentApp(true)
        }

        gd.layout.navigation.autoHideToMore()


    }


    public render() {
        throw Error("3948djd22 Not implemented see child class")
    }

}


